import Util from '@/lib/util'
import _ from "lodash";

export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
        align:"center"
      },
    {
        title:Util.L('Đối tác'),
        key:'product',
        width: 150,
        render:(h:any,params:any)=> { return h("span", !_.isEmpty(_.get(params,'row.product.clientCode')) ? (_.get(params,'row.product.clientCode') + '-' + _.get(params,'row.product.clientName')) : params.row.clientName); }
    },{
        title:Util.L('Ngành hàng'),
        key:'product',
        width: 120,
        render:(h:any,params:any)=> { return h("span", !_.isEmpty(_.get(params,'row.product.productCategory.code')) ? _.get(params,'row.product.productCategory.code')  + '-' +  _.get(params,'row.product.productCategory.name') : params.row.categoryName); }
    },
    {
        title:Util.L('Mã sản phẩm'),
        key:'shortName',
        width: 120,
        render:(h:any,params:any)=> { return h("span", _.get(params,'row.product.sku') || params.row.sku); }
    },
    {
        title:Util.L('Tên sản phẩm'),
        key:'shortName',
        width: 170,
        render:(h:any,params:any)=> { return h("span", _.get(params,'row.product.name')  || params.row.name); }
    },
    {
        title:Util.L('Ngày áp dụng'),
        key:'effectiveDate',
        width: 210,
        align: 'center',
        slot: 'effectiveDate',
    },
    {
        title:Util.L('Thời gian BH(ngày)'),
        key:'duration',
        width: 120,
        align: 'right',
        slot: 'duration',
    },
    {
        title: ' ',
        width:100,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }]

